import { render, staticRenderFns } from "./zones.vue?vue&type=template&id=08d08e22&scoped=true"
import script from "./zones.vue?vue&type=script&lang=js"
export * from "./zones.vue?vue&type=script&lang=js"
import style0 from "./zones.vue?vue&type=style&index=0&id=08d08e22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d08e22",
  null
  
)

export default component.exports